// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__P4mxT","container":"Banner_container__k8Oh8","img":"Banner_img__CYtPx","header":"Banner_header__rft5h"};